import {
    emptyTransactionsReport,
    TransactionsReportStatus,
    type TransactionsReportState
} from './TransactionsReportState';

import {
    TRANSACTIONS_REPORT_GET_START,
    TRANSACTIONS_REPORT_GET_SUCCESS,
    TRANSACTIONS_REPORT_GET_ERROR,
    TransactionsReportAction
} from 'actions/insights/sales/TransactionsReport/TransactionsReportActionsType';

const initialState: TransactionsReportState = {
    report: emptyTransactionsReport(),
    status: TransactionsReportStatus.Initial,
    loading: false
};

export const TransactionsReportReducer = (
    state = initialState,
    action: TransactionsReportAction
): TransactionsReportState => {
    switch (action.type) {
        case TRANSACTIONS_REPORT_GET_START:
            return {
                ...state,
                loading: true,
                status: TransactionsReportStatus.Getting
            };

        case TRANSACTIONS_REPORT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                status: TransactionsReportStatus.GettingSuccess,
                report: action.payload.report
            };

        case TRANSACTIONS_REPORT_GET_ERROR:
            return {
                ...state,
                loading: false,
                status: TransactionsReportStatus.Error
            };

        default:
            return state;
    }
};

export default TransactionsReportReducer;
